import { ChangeEvent } from 'react';
import { FormControl, FormControlLabel, RadioGroup } from '@mui/material';
import { OnboardingSlideProps } from 'models';
import { StyledBox, StyledRadio, StyledTypography } from './MarketingPreferences.styles';

const MarketingPreferences = ({
  onboardingData: { marketingOptIn, buttonState },
  setOnboardingData,
}: OnboardingSlideProps) => {
  const handleOnSelect = (event: ChangeEvent<HTMLInputElement>) => {
    const updatedMarketingOptIn = event.target.value === 'true';
    const updatedButtonState = { ...buttonState, marketing: false };

    setOnboardingData({
      type: 'setMarketingOptIn',
      data: { marketingOptIn: updatedMarketingOptIn },
    });

    setOnboardingData({
      type: 'setButtonState',
      data: { buttonState: updatedButtonState },
    });
  };

  return (
    <StyledBox>
      <FormControl>
        <RadioGroup
          row
          defaultValue={undefined}
          value={marketingOptIn ?? ''}
          onChange={handleOnSelect}
        >
          <FormControlLabel
            value
            control={<StyledRadio />}
            label={
              <StyledTypography variant="h4">
                Yes, my inbox is hungry for exclusive offers like free food & drink
              </StyledTypography>
            }
          />
          <FormControlLabel
            value={false}
            control={<StyledRadio />}
            label={
              <StyledTypography variant="h4">
                No, I’m not interested in offers like free food & drink
              </StyledTypography>
            }
          />
        </RadioGroup>
      </FormControl>
    </StyledBox>
  );
};

export default MarketingPreferences;
